import { CalendarHeart } from "lucide-react";

export const EventDateField = ({ value, onChange }) => (
  <label className="block mb-6 rounded-2xl border border-[#DDD3C6] bg-white/70 p-5" data-testid="event-date-field">
    <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-[#533C25]">
      <CalendarHeart size={16} /> Indiquez la date de votre événement <span className="text-[#B4552D]">*</span>
    </span>
    <input
      type="date"
      lang="fr-FR"
      required
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="mt-3 w-full h-12 rounded-xl border border-[#CDC0B0] bg-white px-4 text-base text-[#3A322B] focus:outline-none focus:ring-2 focus:ring-[#533C25]/30"
      data-testid="event-date-input"
    />
    <span className="block mt-2 text-xs text-[#9A8C7D]">La date s'affiche automatiquement sur votre tableau ; vous pourrez la modifier dans l'étape des textes.</span>
  </label>
);
